import routes from './routes'

export { routes }


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/index.js